(function () {
  const onBlurListMenu = (header) => {
    const listMenuItems = header.querySelectorAll(
      ".list-menu--inline > .list-menu-item"
    );

    const onBlurInnerElements = () => {
      listMenuItems.forEach((item) => {
        item.querySelectorAll("a, details, summary").forEach((el) => {
          el.blur();
        });
        item.blur();
      });
    };

    listMenuItems.forEach((listMenuItem) => {
      listMenuItem.addEventListener("mouseleave", onBlurInnerElements);
    });
  };

  const initHeaderOverlay = (header) => {
    const main = document.getElementById("MainContent");
    const sections = main.querySelectorAll(".shopify-section");
    const isBoxedMode = Boolean(header.querySelector(".header--boxed-mode"));
    const isOverlayMode = Boolean(
      header.querySelector(".header--overlay-mode")
    );

    if (sections.length > 0 && (isBoxedMode || isOverlayMode)) {
      const hasTargetSection = sections[0].classList.contains(
        "has-header-interaction"
      );
      const sectionTargetChild = sections[0].querySelector(
        "[data-header-interaction]"
      );
      const headerGroupSections = document.querySelectorAll(
        ".shopify-section-group-header-group"
      );

      if (hasTargetSection && sectionTargetChild) {
        if (headerGroupSections[headerGroupSections.length - 1] === header) {
          sections[0].classList.remove("not-margin");
          header.classList.remove("not-mode");
          if (isOverlayMode) header.classList.add("overlay-mode-enabled");
        } else {
          sections[0].classList.add("not-margin");
          header.classList.add("not-mode");
          header.classList.remove("overlay-mode-enabled");
        }
      } else {
        header.classList.add("not-mode");
        header.classList.remove("overlay-mode-enabled");
      }
    } else {
      header.classList.add("not-mode");
      header.classList.remove("overlay-mode-enabled");
    }
  };

  const initHeader = () => {
    const header = document.querySelector(".shopify-section-header");
    if (!header) return;

    onBlurListMenu(header);
    initHeaderOverlay(header);
  };

  initHeader();

  document.addEventListener("shopify:section:load", initHeader);
  document.addEventListener("shopify:section:unload", initHeader);
  document.addEventListener("shopify:section:reorder", initHeader);
})();

if (!customElements.get("burger-menu")) {
  customElements.define(
    "burger-menu",
    class BurgerMenu extends HTMLElement {
      constructor() {
        super();
        this.header = document.querySelector(".header-wrapper");
        this.burgerMenu = this.querySelector(".burger-menu");
        this.openButton = this.querySelector(".burger-menu__toggle");
        this.closeButton = this.querySelector(".modal-close-button");
        this.overlayEl = this.querySelector(".modal__overlay");

        this.open = this.onOpen.bind(this);
        this.close = this.onClose.bind(this);
        this.handleKeyDown = this.onHandleKeyDown.bind(this);
      }

      connectedCallback() {
        this.openButton?.addEventListener("click", this.open);
        this.closeButton?.addEventListener("click", this.close);
        this.overlayEl?.addEventListener("click", this.close);
        this.header?.addEventListener("keydown", this.handleKeyDown);
      }

      disconnectedCallback() {
        this.openButton?.removeEventListener("click", this.open);
        this.closeButton?.removeEventListener("click", this.close);
        this.overlayEl?.removeEventListener("click", this.close);
        this.header?.removeEventListener("keydown", this.handleKeyDown);

        // Dropped from the DOM while open (theme editor re-render) — release the body scroll-lock.
        if (this.getAttribute("open")) {
          document.body.classList.remove("overflow-hidden-desktop-menu");
          document.body.classList.remove("overflow-hidden");
          removeTrapFocus();
          if (this.header) this.header.preventHide = false;
        }
      }

      onOpen() {
        if (this.header) this.header.preventHide = true;
        this.setAttribute("open", true);
        this.burgerMenu.classList.add("modal--open");
        document.body.classList.add("overflow-hidden-desktop-menu");
        if (this.burgerMenu && this.closeButton) {
          trapFocus(this.burgerMenu, this.closeButton);
        }
      }

      onClose() {
        document.body.classList.remove("overflow-hidden-desktop-menu");
        document.body.classList.remove("overflow-hidden");
        this.removeAttribute("open");
        this.burgerMenu.classList.remove("modal--open");
        removeTrapFocus(this.openButton);
        this.querySelectorAll("menu-drawer").forEach((submenu) => {
          if (submenu && typeof submenu.closeMenuDrawer === "function") {
            submenu.closeMenuDrawer(this.openButton);
          }
        });
        if (this.header) this.header.preventHide = false;
      }

      onHandleKeyDown(event) {
        if (this.getAttribute("open")) {
          if (event.key === "Escape") {
            this.close();
          }
        }
      }
    }
  );
}

if (!customElements.get("header-search")) {
  customElements.define(
    "header-search",
    class HeaderSearch extends HTMLElement {
      constructor() {
        super();
        this.header = document.querySelector(".header-wrapper");
        this.searchLink = this.querySelector(".header-button__link");
        this.searchLabel = this.searchLink?.querySelector(".header-button__label");
        this.modalContainer = this.querySelector(".header-search-modal");
        this.modalContent = this.querySelector(".header-search-modal__content");
        this.closeButton =
          this.querySelector(".header-search-modal__close") ||
          this.querySelector(".mobile-submenu__back");
        this.overlayEl = this.querySelector(".header-search-modal__overlay");
        this.closeCursor = this.querySelector("modal-close-cursor");
        this.location = this.dataset.location;

        this.searchInput = this.querySelector(
          "#Search-In-Modal, #Search-In-Modal-Mobile"
        );

        this.predictiveSearch = this.querySelector("predictive-search");

        this.open = this.onOpen.bind(this);
        this.close = this.onClose.bind(this);
        this.toggle = this.onToggle.bind(this);
        this.handleKeyDown = this.onHandleKeyDown.bind(this);
        this.handleOutsideClick = this.onOutsideClick.bind(this);
        this.handlePointerEnter = this.onPointerEnter.bind(this);
        this.openedByHover = false;
      }

      connectedCallback() {
        this.searchLink?.addEventListener("click", this.toggle);
        this.searchLabel?.addEventListener("pointerenter", this.handlePointerEnter);
        this.closeButton?.addEventListener("click", this.close);
        this.overlayEl?.addEventListener("click", this.close);
        this.header?.addEventListener("keydown", this.handleKeyDown);

        this.setTimeout = null;
        this.outsideClickRaf = null;
        this.closingTimeout = null;
      }

      disconnectedCallback() {
        this.searchLink?.removeEventListener("click", this.toggle);
        this.searchLabel?.removeEventListener("pointerenter", this.handlePointerEnter);
        this.closeButton?.removeEventListener("click", this.close);
        this.overlayEl?.removeEventListener("click", this.close);
        this.header?.removeEventListener("keydown", this.handleKeyDown);
        document.removeEventListener("mousedown", this.handleOutsideClick);
        if (this.outsideClickRaf) {
          cancelAnimationFrame(this.outsideClickRaf);
          this.outsideClickRaf = null;
        }
        this.closingTimeout && window.clearTimeout(this.closingTimeout);
        this.setTimeout && window.clearTimeout(this.setTimeout);
        this.closeCursor?.deactivate();

        // Dropped from the DOM while open (theme editor re-render) — release the body scroll-lock.
        if (this.getAttribute("open")) {
          if (this.location === "desktop-header") {
            document.body.classList.remove("overflow-hidden");
          }
          removeTrapFocus();
          if (this.header) this.header.preventHide = false;
        }
      }

      onPointerEnter(event) {
        if (
          event.pointerType !== "mouse" ||
          this.location !== "desktop-header" ||
          !window.matchMedia("(min-width: 1161px) and (hover: hover) and (pointer: fine)").matches ||
          this.hasAttribute("open")
        ) return;

        this.openedByHover = true;
        this.open(event);
      }

      onOpen(event) {
        event.preventDefault();
        this.setTimeout && window.clearTimeout(this.setTimeout);
        if (this.header) this.header.preventHide = true;
        this.setAttribute("open", true);
        this.modalContainer.classList.add("header-search-modal--open");

        // Cancel any in-flight close so re-opening keeps the header solid.
        this.closingTimeout && window.clearTimeout(this.closingTimeout);
        this.modalContainer.classList.remove("header-search-modal--closing");

        // Hovering the trigger usually armed the transition already, but not on a tap
        // or when the modal is opened programmatically — make it explicit.
        this.closest(".header")?.dispatchEvent(
          new CustomEvent("header:panel-opened")
        );

        // transition duration in modal 300ms
        if (this.searchInput && navigator.userAgent.indexOf("iPhone") === -1) {
          this.setTimeout = setTimeout(() => {
            trapFocus(this.modalContainer, this.searchInput);
          }, 300);
        }

        if (this.location === "desktop-header") {
          document.body.classList.add("overflow-hidden");
        }

        if (this.predictiveSearch) {
          const collectionEl = this.querySelector(
            ".header-search-modal__collection"
          );
          const collectionHeight = parseInt(
            collectionEl?.getBoundingClientRect().height
          );

          // Skip when 0 — collections are hidden behind active search results,
          // keep the previously measured value
          if (collectionHeight > 0) {
            this.style.setProperty(
              "--search-collections-height",
              `${collectionHeight}px`
            );
          }

          const searchField = this.querySelector(".header-search-modal__field");
          const searchFieldHeight = parseInt(
            searchField?.getBoundingClientRect().height
          );

          if (searchFieldHeight > 0) {
            this.style.setProperty(
              "--search-field-height",
              `${searchFieldHeight}px`
            );
          }
        }

        this.closeCursor?.activate();

        if (this.outsideClickRaf) cancelAnimationFrame(this.outsideClickRaf);
        this.outsideClickRaf = requestAnimationFrame(() => {
          document.addEventListener("mousedown", this.handleOutsideClick);
          this.outsideClickRaf = null;
        });
      }

      onClose() {
        this.openedByHover = false;
        this.setTimeout && window.clearTimeout(this.setTimeout);
        this.removeAttribute("open");
        this.modalContainer.classList.remove("header-search-modal--open");

        // In overlay mode the header stays solid while the modal is open (the
        // overlay styles exclude `.header-search-modal--open`). The modal animates
        // out over ~900ms, so hold a `--closing` flag for that long to keep the
        // header solid until the white modal is fully gone — otherwise it flips
        // transparent behind the still-closing modal.
        this.modalContainer.classList.add("header-search-modal--closing");
        this.closingTimeout && window.clearTimeout(this.closingTimeout);
        this.closingTimeout = window.setTimeout(() => {
          this.modalContainer.classList.remove("header-search-modal--closing");
          this.closest(".header")?.dispatchEvent(
            new CustomEvent("header:panel-closed")
          );
        }, 900);

        document.removeEventListener("mousedown", this.handleOutsideClick);

        if (this.outsideClickRaf) {
          cancelAnimationFrame(this.outsideClickRaf);
          this.outsideClickRaf = null;
        }

        this.closeCursor?.deactivate();

        if (this.location === "desktop-header") {
          document.body.classList.remove("overflow-hidden");
        }

        removeTrapFocus(this.searchLink);

        if (this.header) this.header.preventHide = false;

        const parentMenu = this.closest("header-drawer");

        if (!parentMenu) removeTrapFocus(this.searchLink);

        if (parentMenu) {
          removeTrapFocus(parentMenu.closeBtn);
          const parentOpenScrollY = parentMenu.openScrollY || 0;
          window.scrollTo(0, parentOpenScrollY);
        }
      }

      onToggle(event) {
        if (this.getAttribute("open")) {
          event.preventDefault();
          if (this.openedByHover) {
            this.openedByHover = false;
            this.searchInput?.focus();
            return;
          }
          this.close();
        } else {
          this.open(event);
        }
      }

      onHandleKeyDown(event) {
        if (this.getAttribute("open")) {
          if (event.key === "Escape") {
            this.close();
          }
        }
      }

      onOutsideClick(event) {
        if (!this.getAttribute("open")) return;
        if (!this.modalContent) return;
        if (this.modalContent.contains(event.target)) return;
        if (this.searchLink && this.searchLink.contains(event.target)) return;
        this.close();
      }
    }
  );
}

// Overlay header: hovering the menu or the search switches it to the solid base scheme.
(function () {
  const BREAKPOINT = 1100;
  const ANIMATE_HOLD = 300; // ms, matches --overlay-transition in header.scss
  const bound = new WeakSet();
  // Points at the live header's reset. The theme editor re-renders the section, so the
  // window-level resize listener below has to reach the current element, not a detached one.
  let resetActiveHeader = null;

  // Mirrors the CSS: the hover swap only exists where there's a real pointer.
  const canHover = () =>
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  // matches(":focus-visible") throws where the pseudo-class is unknown (Safari < 15.4).
  // Degrade to "not keyboard-focused" instead of letting it break the caller.
  const isKeyboardFocused = (node) => {
    try {
      return !!node?.matches(":focus-visible");
    } catch {
      return false;
    }
  };

  const initHoverScheme = () => {
    const header = document.querySelector(
      ".header--overlay-mode[data-hover-animation='true']"
    );
    if (!header || bound.has(header)) return;

    // Only the menu and the search trigger the swap: both open a panel *under* the header
    // in the base (light) scheme, so the header has to match it or the seam shows. The
    // remaining buttons open drawers/sheets that carry their own scheme, so hovering them
    // leaves the header transparent.
    const zones = header.querySelectorAll(".header-menu, .header-search");
    if (!zones.length) return;

    bound.add(header);

    const wrapper = header.closest(".header-wrapper");
    let animateTimer = null;

    // Both panels are DOM descendants of their zone, so moving into an open mega-menu
    // or search modal still counts as "inside" and never drops the scheme.
    const isInsideZones = (node) =>
      !!node && Array.from(zones).some((zone) => zone.contains(node));

    // Pointer or keyboard focus is on a zone right now.
    // `:hover` is only trusted on real pointers — touch leaves it stuck on the last
    // tapped element, which would pin the transition gate on and bring back the flicker.
    // `:focus-visible`, not plain focus: closing the search modal always parks focus back
    // on its trigger (removeTrapFocus calls .focus()), so a mouse user who clicked the
    // close button would otherwise read as "still engaged" and the header would stay
    // solid for good. Only a keyboard user should hold it there.
    const isEngaged = () =>
      (canHover() &&
        Array.from(zones).some((zone) => zone.matches(":hover"))) ||
      (isKeyboardFocused(document.activeElement) &&
        isInsideZones(document.activeElement));

    // The overlay / base color schemes are applied via CSS (header-overlay-mode-styles.liquid).
    // This just toggles `.hover-active` so that CSS can switch the header to the base scheme,
    // plus `.animate-triggered` — the gate that makes the swap animate. Without that gate the
    // scheme changes instantly, which is what we want on scroll and on first paint.
    const addBackground = () => {
      if (window.innerWidth < BREAKPOINT) return;
      clearTimeout(animateTimer);
      wrapper?.classList.add("animate-triggered");
      header.classList.add("hover-active");
    };

    const removeBackground = (event) => {
      // `focusout` bubbles, so moving focus between menu descendants fires this handler
      // even though focus never left the zone. Checking against the zones (not the whole
      // header) also covers hopping straight from the menu to the search without a blink.
      if (event && isInsideZones(event.relatedTarget)) return;
      // While any panel is on screen — including its close animation — the header has
      // to stay solid, or it flashes transparent behind a still-visible white panel.
      // Each panel fires `header:panel-closed` once it's gone so we can re-check then.
      if (header.querySelector(".header-search-modal--open")) return;
      if (header.querySelector(".header-search-modal--closing")) return;
      if (header.querySelector(".header-account-modal--open")) return;
      if (header.querySelector(".header-account-modal--closing")) return;
      if (header.querySelector(".mega-menu-open")) return;
      if (header.querySelector(".mega-menu-closing")) return;
      header.classList.remove("hover-active");
      // Hold the transition through the fade back to transparent, then drop the gate.
      clearTimeout(animateTimer);
      animateTimer = setTimeout(() => {
        wrapper?.classList.remove("animate-triggered");
      }, ANIMATE_HOLD);
    };

    zones.forEach((zone) => {
      zone.addEventListener("mouseenter", addBackground);
      zone.addEventListener("mouseleave", removeBackground);
      // `focusin`, not `focus` — focus doesn't bubble, so tabbing into a menu link
      // would never reach a listener on the zone itself.
      zone.addEventListener("focusin", addBackground);
      zone.addEventListener("focusout", removeBackground);
    });

    // A panel opened. CSS alone drives its scheme swap (the `:has(...)` exclusions in
    // header-overlay-mode-styles.liquid), so all it needs from here is the transition
    // gate — not .hover-active, which stays the hover zones' business. Covers the panels
    // no zone owns (the account sheet) and taps, where hover events can't be relied on.
    header.addEventListener("header:panel-opened", () => {
      clearTimeout(animateTimer);
      wrapper?.classList.add("animate-triggered");
    });

    // A panel finished closing. The pointer may have left the header long ago — its
    // mouseleave was swallowed by the guards above and nothing will fire it again —
    // so re-check here, while .animate-triggered is still on and the fade can play.
    header.addEventListener("header:panel-closed", () => {
      if (isEngaged()) return;
      removeBackground();
    });

    // If the pointer already sits over the menu when this (deferred) script runs
    // — page loaded/reloaded with the cursor there — mouseenter never fires, so the
    // header would stay transparent while a mega-menu is already open. Sync now.
    if (isEngaged()) addBackground();

    resetActiveHeader = removeBackground;
  };

  initHoverScheme();
  // Header is re-rendered in the theme editor; wire up the fresh element.
  document.addEventListener("shopify:section:load", initHoverScheme);

  // Bound once, outside init: re-running init per section:load would otherwise stack a
  // new listener each time, every one of them still holding a detached header.
  window.addEventListener("resize", () => {
    if (window.innerWidth < BREAKPOINT) resetActiveHeader?.();
  });
})();

// Keeps the header in its solid base color scheme while the Shopify account sheet
// (<shopify-account>, the "Shopify based" account modal) is open in overlay mode.
// The component fires `open` / `close` events; we mirror them onto marker classes on
// the element itself (a descendant of .header), which the overlay styles exclude via
// `:has(.header-account-modal--open, .header-account-modal--closing)` — see
// header-overlay-mode-styles.liquid. Without this the header flips to the transparent
// overlay scheme when the pointer leaves the viewport, and the sheet (which inherits
// the header's color scheme) renders dark.
(function () {
  const CLOSING_DURATION = 500; // ms, hold the header solid through the sheet's close animation
  const bound = new WeakSet();

  const initAccountModalState = () => {
    document.querySelectorAll("shopify-account").forEach((el) => {
      // The element survives some re-renders; only wire each instance once.
      if (bound.has(el)) return;
      bound.add(el);

      let closingTimer = null;

      el.addEventListener("open", () => {
        closingTimer && clearTimeout(closingTimer);
        closingTimer = null;
        el.classList.remove("header-account-modal--closing");
        el.classList.add("header-account-modal--open");
        // No hover zone owns this button, so without the signal the header would snap
        // between schemes instead of fading with the sheet.
        el.closest(".header")?.dispatchEvent(
          new CustomEvent("header:panel-opened")
        );
      });

      el.addEventListener("close", () => {
        el.classList.remove("header-account-modal--open");
        // Hold a solid header through the close animation so it doesn't flash
        // transparent behind the still-animating sheet (mirrors the search modal).
        el.classList.add("header-account-modal--closing");
        closingTimer && clearTimeout(closingTimer);
        closingTimer = setTimeout(() => {
          el.classList.remove("header-account-modal--closing");
          closingTimer = null;
          el.closest(".header")?.dispatchEvent(
            new CustomEvent("header:panel-closed")
          );
        }, CLOSING_DURATION);
      });
    });
  };

  initAccountModalState();
  // The header section is re-rendered in the theme editor; re-wire new instances.
  document.addEventListener("shopify:section:load", initAccountModalState);
})();

// Shrinks the logo across the overlay first section, then keeps it compact.
// Desktop only, and only when overlay mode is actually active on the page.
// Through that first section the header is pinned at the top so the shrink is
// visible, and the pin stays transparent (overlay scheme) via our own class
// instead of .shopify-section-header-sticky. At the section boundary the header
// is handed back to <sticky-header>, which then hides/reveals it ("on-scroll-up")
// or keeps it solid-sticky ("always"). "none" has no <sticky-header>, so it
// never animates.
(function () {
  const MIN_RANGE = 200; // px, lower bound for the pin range (short sections)
  const MAX_SHRINK = 500; // px, cap the logo shrink distance on tall sections
  const PIN_CLASS = "shopify-section-header--anim-pin";
  const SHRUNK_CLASS = "shopify-section-header--logo-shrunk";
  const LEAVE_DURATION = 850; // ms, matches the .animate transform transition
  // Matches the SCSS gate on .header--logo-animation ($xl-small): from here up the inline
  // menu replaces the drawer and the header row is pinned to the top for the shrink.
  const desktopMq = window.matchMedia("(min-width: 1160px)");

  // Eased shrink so it doesn't feel mechanical (gentle at the start and end).
  const easeInOutCubic = (t) =>
    t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

  // Re-resolved on every section render: the theme editor replaces the header element,
  // so refs taken on first paint would animate a detached node after a setting change.
  let header = null;
  let logoWrapper = null;
  let logoLink = null;
  let headerRow = null; // inner .header — its min-height and padding shape the header height
  let stickyEl = null;
  let stickyAlways = false;
  let startWidth = 0; // logo width at the top of the page
  let restWidth = 0; // logo width once the shrink is done (the Logo width setting)
  let heightRatio = 0; // logo height per 1px of width
  // Read once, to derive the header height from the logo size without measuring it.
  let minHeaderHeight = 0; // .header min-height
  let headerChrome = 0; // the insets the logo box sits between
  let sectionExtra = 0; // anything the section wrapper adds around .header (normally 0)

  let range = MIN_RANGE; // scroll distance of the first section (pin / leave)
  let shrinkRange = MIN_RANGE; // logo shrink distance, capped at MAX_SHRINK
  let stateRaf = null;
  let active = false;
  let pinned = false; // header currently in the transparent pinned state
  let leaveTimer = null; // pending solidify-after-the-transparent-slide

  const resolve = () => {
    header = document.querySelector(".shopify-section-header");
    if (!header) return false;

    // Direct-child combinator on purpose: header-drawer also renders a
    // header-logo (the mobile drawer logo, .logo-in-drawer) nested deeper inside
    // .header-drawer-wrapper. Without `>` querySelector would grab that hidden
    // drawer logo (earlier in the DOM) and resize it instead of the real one.
    logoWrapper = header.querySelector(
      ".header-drawer-wrapper > .logo-wrapper[data-logo-animation='true'], .header-inner > .logo-wrapper[data-logo-animation='true']"
    );
    logoLink = logoWrapper && logoWrapper.querySelector(".logo-link");
    headerRow = logoWrapper && logoWrapper.closest(".header");
    stickyEl = header.querySelector("sticky-header.header-wrapper");
    // No logo to animate, or sticky type is "none" (no <sticky-header>).
    if (!logoWrapper || !logoLink || !headerRow || !stickyEl) return false;

    stickyAlways = stickyEl.getAttribute("data-sticky-type") === "always";
    restWidth = parseFloat(logoLink.dataset.logoWidth) || 0;
    startWidth = parseFloat(logoLink.dataset.logoAnimationWidth) || restWidth;
    heightRatio = (parseFloat(logoLink.dataset.logoRatio) || 0) / 100;

    return Boolean(restWidth && heightRatio);
  };

  const measureRange = () => {
    const main = document.getElementById("MainContent");
    const firstSection = main && main.querySelector(".shopify-section");
    const headerHeight = header.getBoundingClientRect().height;
    range = firstSection
      ? Math.max(
          firstSection.getBoundingClientRect().height - headerHeight,
          MIN_RANGE
        )
      : MIN_RANGE;
    // Logo finishes shrinking within the first MAX_SHRINK px (so it doesn't
    // crawl on a tall hero), but the header stays pinned for the whole section.
    shrinkRange = Math.min(range, MAX_SHRINK);
  };

  // Derived, never measured: reading the header back right after resizing it forces a layout
  // mid-frame, and the write that follows dirties style again — two passes instead of one,
  // which is most of the frame cost. Same value and precision the ResizeObserver publishes.
  const publishHeaderHeight = (logoBoxHeight) => {
    const height =
      sectionExtra + Math.max(minHeaderHeight, headerChrome + logoBoxHeight);
    document.documentElement.style.setProperty(
      "--header-height",
      height.toFixed(2) + "px"
    );
  };

  const clearLeaveTimer = () => {
    if (leaveTimer) {
      clearTimeout(leaveTimer);
      leaveTimer = null;
    }
  };

  // Transparent pin: hold the header at the top with our own class (NOT
  // .shopify-section-header-sticky, so the overlay transparency is kept) and
  // keep <sticky-header> from hiding / revealing / solidifying it. `animate` is
  // left untouched so any transform left over from a previous state settles
  // smoothly (e.g. sliding back down when scrolling up into the section).
  const setPinned = () => {
    clearLeaveTimer();
    pinned = true;
    stickyEl.preventHide = true;
    stickyEl.preventReveal = true;
    stickyEl.headerIsAlwaysSticky = false;
    header.classList.add(PIN_CLASS);
    header.classList.remove(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky"
    );
  };

  // At the very top: no pin, transparent header back in normal flow, owned by
  // <sticky-header>.
  const setReleasedTop = () => {
    clearLeaveTimer();
    pinned = false;
    stickyEl.preventHide = false;
    stickyEl.preventReveal = false;
    stickyEl.headerIsAlwaysSticky = stickyAlways;
    header.classList.remove(
      PIN_CLASS,
      SHRUNK_CLASS,
      "shopify-section-header-hidden",
      "shopify-section-header-sticky",
      "animate"
    );
  };

  // Leaving the first section: slide the STILL-transparent header up (PIN_CLASS
  // keeps it transparent + sticky-positioned, `hidden` translates it up,
  // `animate` smooths it). Only once it has fully left the screen do we swap to
  // the solid sticky class and hand control back to <sticky-header> — invisible,
  // since the header is already gone, so there's no color flash on detach.
  const leaveAndRelease = () => {
    if (stickyAlways) {
      clearLeaveTimer();
      pinned = false;
      stickyEl.preventHide = false;
      stickyEl.preventReveal = false;
      stickyEl.headerIsAlwaysSticky = true;
      header.classList.remove(
        PIN_CLASS,
        "shopify-section-header-hidden",
        "animate"
      );
      header.classList.add("shopify-section-header-sticky");
      return;
    }

    pinned = false;
    header.classList.add("shopify-section-header-hidden", "animate");
    leaveTimer = setTimeout(() => {
      leaveTimer = null;
      stickyEl.preventHide = false;
      stickyEl.preventReveal = false;
      stickyEl.headerIsAlwaysSticky = stickyAlways;
      header.classList.remove(PIN_CLASS);
      header.classList.add("shopify-section-header-sticky");
    }, LEAVE_DURATION);
  };

  // Width and height go together at the logo's own ratio so it scales as one box: a plain
  // `width: auto` collapses here, because the link is inline-flex with an aspect-ratio
  // ::after spacer and the image's `width: 100%` has no stable width to resolve against.
  //
  // --header-height is published from here, in the same frame as the resize. The header's
  // ResizeObserver would otherwise do it a frame later, costing a second document-wide
  // recalc per frame and leaving the overlay offset of the first section one frame behind.
  const apply = () => {
    const scrollY = window.scrollY;
    const eased = easeInOutCubic(
      Math.min(Math.max(scrollY / shrinkRange, 0), 1)
    );
    const width = startWidth + (restWidth - startWidth) * eased;
    const logoBoxHeight = width * heightRatio;
    logoLink.style.width = width + "px";
    logoWrapper.style.height = logoBoxHeight + "px";
    publishHeaderHeight(logoBoxHeight);
    header.classList.toggle(SHRUNK_CLASS, scrollY >= shrinkRange);

    if (scrollY <= 0) {
      setReleasedTop();
    } else if (scrollY < range) {
      if (!pinned) setPinned();
    } else if (pinned) {
      leaveAndRelease();
    }
  };

  const onScroll = () => {
    if (stateRaf) return;
    stateRaf = requestAnimationFrame(() => {
      stateRaf = null;
      apply();
    });
  };

  const enable = () => {
    if (active) return;
    active = true;

    const rowStyle = getComputedStyle(headerRow);
    minHeaderHeight = parseFloat(rowStyle.minHeight) || 0;
    headerChrome =
      (parseFloat(rowStyle.paddingTop) || 0) +
      (parseFloat(getComputedStyle(logoWrapper).marginBottom) || 0);
    sectionExtra =
      header.getBoundingClientRect().height -
      headerRow.getBoundingClientRect().height;

    // Owns --header-height while running, so the observer stops publishing it.
    header.dataset.logoAnim = "active";
    logoWrapper.style.transition = "none"; // scroll-linked, avoid lag
    measureRange();
    apply();
    window.addEventListener("scroll", onScroll, { passive: true });
  };

  const disable = () => {
    if (!active) return;
    active = false;
    window.removeEventListener("scroll", onScroll);
    if (stateRaf) cancelAnimationFrame(stateRaf);
    stateRaf = null;
    clearLeaveTimer();
    pinned = false;
    logoWrapper.style.height = "";
    logoWrapper.style.transition = "";
    // Back to the resting size that .logo-link carries by default. Clearing these resizes
    // the header, so the observer wakes up and takes --header-height back over.
    logoLink.style.width = "";
    delete header.dataset.logoAnim;
    header.classList.remove(PIN_CLASS, SHRUNK_CLASS);
    stickyEl.preventHide = false;
    stickyEl.preventReveal = false;
    stickyEl.headerIsAlwaysSticky = stickyAlways;
  };

  const update = () => {
    if (!header) return;
    if (
      desktopMq.matches &&
      header.classList.contains("overlay-mode-enabled")
    ) {
      enable();
    } else {
      disable();
    }
  };

  const init = () => {
    if (header) disable();
    if (!resolve()) {
      header = null;
      return;
    }
    update();
  };

  init();

  desktopMq.addEventListener("change", update);
  window.addEventListener("resize", () => {
    if (!active) return;
    measureRange();
    apply();
  });
  // initHeaderOverlay re-evaluates the overlay state on section load/unload (theme
  // editor) and the header element itself is replaced, so re-resolve rather than
  // re-checking refs that are already detached.
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:unload", init);
})();

// Keeps the cascading submenu fully on-screen on narrow desktop widths. The
// second-level submenu opens to the side of its parent (right by default, left
// in RTL — CSS: .header-submenu-lvl-2), so for a top-level item near the screen
// edge it can overflow the viewport. Instead of flipping the second level, we
// shift the whole first-level submenu sideways by the overflow amount, so the
// second level still opens in its default direction and fits. Measured on the
// rendered box (submenus are visibility:hidden but still laid out).
// Direction-agnostic, so RTL is covered too.
(function () {
  const EDGE_MARGIN = 8; // px breathing room from the viewport edge

  const positionSubmenus = () => {
    document.querySelectorAll(".header__submenu").forEach((submenu) => {
      // Measure in the unshifted state, so resize re-evaluates from scratch.
      submenu.style.transform = "";

      const lvl2Items = submenu.querySelectorAll(".header-submenu-lvl-2");
      if (!lvl2Items.length) return;

      let overflowRight = 0;
      let overflowLeft = 0;

      lvl2Items.forEach((lvl2) => {
        const rect = lvl2.getBoundingClientRect();
        // Not laid out (e.g. inline menu hidden on mobile) — skip.
        if (rect.width === 0 && rect.height === 0) return;
        overflowRight = Math.max(
          overflowRight,
          rect.right - (window.innerWidth - EDGE_MARGIN)
        );
        overflowLeft = Math.max(overflowLeft, EDGE_MARGIN - rect.left);
      });

      if (overflowRight > 0) {
        submenu.style.transform = `translateX(${-overflowRight}px)`;
      } else if (overflowLeft > 0) {
        submenu.style.transform = `translateX(${overflowLeft}px)`;
      }
    });
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      positionSubmenus();
    });
  };

  positionSubmenus();

  // Late layout shifts (web fonts) can change menu item widths.
  window.addEventListener("load", schedule);
  window.addEventListener("resize", schedule);
  document.addEventListener("shopify:section:load", positionSubmenus);
})();

// Keeps a mega-menu open while the pointer travels from its trigger to the panel.
// The panel is fixed below the whole header, so when the menu wraps and the
// trigger lands in an upper row, the cursor crosses the lower row(s) on its way
// down — those are sibling items, so the trigger's :hover (and the pure-CSS open)
// drops mid-transit. We hold an explicit .mega-menu-open class across that gap.
(function () {
  const CLOSE_DELAY = 100; // ms grace to cross the gap between trigger and panel
  const CLOSING_DURATION = 600; // ms, matches .mega-menu__wrapper's translateY transition
  const OPEN_CLASS = "mega-menu-open";
  const CLOSING_CLASS = "mega-menu-closing";
  const bound = new WeakSet();

  let openItem = null;
  let closeTimer = null;
  let closingItem = null;
  let closingTimer = null;

  // global.js listens for "megamenu:closed" to reset the menu's tab state
  // back to its default (first item's submenu open) for the next open.
  const notifyClosed = (item) => {
    item.dispatchEvent(new CustomEvent("megamenu:closed", { bubbles: true }));
  };

  const open = (item) => {
    clearTimeout(closeTimer);
    // A clicked submenu control must not keep its old menu open via
    // :focus-within when the pointer deliberately opens another menu.
    const focused = document.activeElement;
    const focusedMenu = focused?.closest(".list-menu-item.list-menu--megamenu");
    if (focusedMenu && focusedMenu !== item) focused.blur();
    // Re-opening during the slide-out: cancel the closing state immediately.
    if (closingItem) {
      clearTimeout(closingTimer);
      closingItem.classList.remove(CLOSING_CLASS);
      closingItem = null;
      closingTimer = null;
    }
    if (openItem && openItem !== item) {
      openItem.classList.remove(OPEN_CLASS);
      notifyClosed(openItem);
    }
    openItem = item;
    item.classList.add(OPEN_CLASS);
  };

  // On close, let an overlay header drop back to transparent in sync with the panel's
  // slide. The hover module bails while .mega-menu-closing is present, so tell it to
  // re-check once the animation is done — same signal the search and account modals use.
  const syncOverlayHeader = () => {
    document
      .querySelector(".header--overlay-mode[data-hover-animation='true']")
      ?.dispatchEvent(new CustomEvent("header:panel-closed"));
  };

  const scheduleClose = () => {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      if (openItem) {
        const itemToClose = openItem;
        const focused = document.activeElement;
        if (itemToClose.contains(focused) && !focused.matches(":focus-visible")) {
          focused.blur();
        }
        // Hold .mega-menu-closing so the header stays solid through the slide-out
        // (mirrors header-search-modal--closing in the search modal).
        itemToClose.classList.add(CLOSING_CLASS);
        itemToClose.classList.remove(OPEN_CLASS);
        clearTimeout(closingTimer);
        closingItem = itemToClose;
        closingTimer = setTimeout(() => {
          itemToClose.classList.remove(CLOSING_CLASS);
          closingItem = null;
          closingTimer = null;
          syncOverlayHeader();
          notifyClosed(itemToClose);
        }, CLOSING_DURATION);
      }
      openItem = null;
    }, CLOSE_DELAY);
  };

  const initMegaMenuHover = () => {
    document
      .querySelectorAll(".list-menu-item.list-menu--megamenu")
      .forEach((item) => {
        if (bound.has(item)) return;
        bound.add(item);

        const panel = item.querySelector(".mega-menu");
        item.addEventListener("mouseenter", () => open(item));
        item.addEventListener("mouseleave", scheduleClose);
        panel?.addEventListener("mouseenter", () => open(item));
        panel?.addEventListener("mouseleave", scheduleClose);
      });
  };

  initMegaMenuHover();
  // Header is re-rendered in the theme editor; wire up any fresh triggers.
  document.addEventListener("shopify:section:load", initMegaMenuHover);
})();

